/**
 * Datos públicos del sitio que muestra el footer (redes sociales, bot de Telegram y correo de contacto de las páginas legales).
 * Las redes sin enlace se muestran como icono sin vínculo. Se pueden sobreescribir en el build con
 * variables VITE_* sin tocar código.
 */
const env = import.meta.env as Record<string, string | undefined>;

export const SITE_INFO = {
  contactEmail: env.VITE_CONTACT_EMAIL ?? 'contact@agrovid.solutions',
  social: {
    facebook:  env.VITE_SOCIAL_FACEBOOK  ?? '',
    instagram: env.VITE_SOCIAL_INSTAGRAM ?? '',
    linkedin:  env.VITE_SOCIAL_LINKEDIN  ?? '',
    youtube:   env.VITE_SOCIAL_YOUTUBE   ?? '',
    x:         env.VITE_SOCIAL_X         ?? '',
  },
  /**
   * Enlace al bot de campo de Telegram. Sigue al mismo bot que el deep-link de vinculación
   * (VITE_TELEGRAM_BOT_USERNAME, por entorno) para que dev apunte a @AgrovidDevBot.
   */
  botUrl: env.VITE_TELEGRAM_BOT_URL
    ?? (env.VITE_TELEGRAM_BOT_USERNAME?.trim()
      ? `https://t.me/${env.VITE_TELEGRAM_BOT_USERNAME.trim()}`
      : 'https://t.me/agrovid_bot'),
} as const;

export type SocialNetwork = keyof typeof SITE_INFO.social;
